import TheService from "@rws-framework/client/src/services/_service";
import type { AnnouncementMongo } from 'src/types/announcement';
import { HTTPClient, HTTPError } from "../services/httpClient";
import type { Catalog } from "src/types/adminServiceTypes";

class AnnouncementService extends TheService {
  static _IN_CLIENT: boolean = true;
  private client = new HTTPClient({
    formatError: AnnouncementsError.fromResponse,
  });

  public async get(catalog_id: string): Promise<AnnouncementMongo[]> {
    // announcements:get_catalog
    return this.client.get(`/announcements/${catalog_id}`);
  }

  public async getAllCatalogs(): Promise<AnnouncementMongo[]> {
    // announcements:get_all
    return this.client.get('/announcements');
  }

  public async create(announcement: AnnouncementMongo): Promise<string> {
    // announcement:create
    return this.client.post(`/announcement`, { body: announcement });
  }

  public async edit(announcement: AnnouncementMongo) {
    // announcement:edit
    return this.client.put(`/announcement/${announcement._id}`, { body: announcement });
  }

  public async deleteAnnouncement(announcement_id: string) {
    // announcement:delete
    return this.client.delete(`/announcement/${announcement_id}`);
  }

  public async getCatalogs(): Promise<Catalog[]> {
    // administration:adoptions
    return this.client.get('/administration/adoptions/1/0/0').then(
      data => data.catalog
    );
  }
}

export default AnnouncementService.getSingleton()

export { AnnouncementService as AnnouncementServiceInstance }

export class AnnouncementsError extends HTTPError {
  get humanMessage() {
    switch (this.errorCode) {
      default:
        return super.humanMessage;
    }
  }
}
